import React from "react";
import { FiRefreshCcw, FiRotateCcw, FiSearch } from "react-icons/fi";

import AdminButton from "../../_shared/ui/AdminButton";

import {
  TROMBINOS_ELECTED_FILTER_OPTIONS,
  TROMBINOS_LIMIT_OPTIONS,
  TROMBINOS_VISIBLE_FILTER_OPTIONS,
} from "../data/trombinosAdminData";

export default function TrombinosFiltersPanel({
  q,
  electedFilter,
  visibleFilter,
  serviceFilter,
  servicesOptions = [],
  limit,
  onChangeQ,
  onChangeElectedFilter,
  onChangeVisibleFilter,
  onChangeServiceFilter,
  onChangeLimit,
  onSubmit,
  onReset,
  onRefresh,
  loading,
}) {
  return (
    <section className="mt-5 rounded-[2rem] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-5">
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="grid gap-4 xl:grid-cols-[1fr_230px_230px_260px]">
          <div>
            <label className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
              Rechercher un profil
            </label>

            <div className="mt-2 flex min-h-12 items-center gap-3 rounded-2xl border border-slate-200 bg-slate-50 px-4 transition focus-within:border-sky-400 focus-within:bg-white focus-within:ring-4 focus-within:ring-sky-100 dark:border-slate-700 dark:bg-slate-950 dark:focus-within:border-sky-500 dark:focus-within:ring-sky-500/10">
              <FiSearch className="text-slate-400" />

              <input
                value={q}
                onChange={(event) => onChangeQ(event.target.value)}
                placeholder="Nom, prénom, fonction, groupe..."
                className="h-11 min-w-0 flex-1 bg-transparent text-sm font-medium text-slate-800 outline-none placeholder:text-slate-400 dark:text-slate-100"
              />
            </div>
          </div>

          <div>
            <label className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
              Type de profil
            </label>

            <select
              value={electedFilter}
              onChange={(event) => onChangeElectedFilter(event.target.value)}
              className="mt-2 h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:focus:border-sky-500 dark:focus:ring-sky-500/10"
            >
              {TROMBINOS_ELECTED_FILTER_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
              Visibilité
            </label>

            <select
              value={visibleFilter}
              onChange={(event) => onChangeVisibleFilter(event.target.value)}
              className="mt-2 h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:focus:border-sky-500 dark:focus:ring-sky-500/10"
            >
              {TROMBINOS_VISIBLE_FILTER_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
              Service rattaché
            </label>

            <select
              value={serviceFilter}
              onChange={(event) => onChangeServiceFilter(event.target.value)}
              className="mt-2 h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:focus:border-sky-500 dark:focus:ring-sky-500/10"
            >
              <option value="all">Tous les services</option>

              {servicesOptions.map((service) => (
                <option key={service.id} value={service.id}>
                  {service.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="grid gap-4 lg:grid-cols-[180px_1fr] lg:items-end">
          <div>
            <label className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
              Affichage
            </label>

            <select
              value={limit}
              onChange={(event) => onChangeLimit(Number(event.target.value))}
              className="mt-2 h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:focus:border-sky-500 dark:focus:ring-sky-500/10"
            >
              {TROMBINOS_LIMIT_OPTIONS.map((value) => (
                <option key={value} value={value}>
                  {value} / page
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-wrap gap-2 lg:justify-end">
            <AdminButton
              type="submit"
              icon={FiSearch}
              variant="dark"
              loading={loading}
            >
              Rechercher
            </AdminButton>

            <AdminButton
              icon={FiRefreshCcw}
              variant="secondary"
              onClick={onRefresh}
              loading={loading}
            >
              Actualiser
            </AdminButton>

            <AdminButton icon={FiRotateCcw} variant="ghost" onClick={onReset}>
              Réinitialiser
            </AdminButton>
          </div>
        </div>
      </form>
    </section>
  );
}